import { connect } from 'react-redux';
import Login from './Login';
import { mapStateToProps, mapDispatchToProps } from './Login.state';

export default connect(mapStateToProps, mapDispatchToProps)(Login);
